export const CROP_ATTRIBUTE_TYPES = {
  continous: { id: 1, name: 'Continuo' },
  boolean: { id: 2, name: 'Booleano' },
}